import { render, staticRenderFns } from "./AddProductToCartRestrictedModal.vue?vue&type=template&id=49dca0bf"
import script from "./AddProductToCartRestrictedModal.vue?vue&type=script&lang=js"
export * from "./AddProductToCartRestrictedModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports